import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { SubstancesProvider, type SubstanceType } from "./SubstancesContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";
import { SubstancesIntroScreen } from "./screens/SubstancesIntroScreen";
import { SubstancesSelectScreen } from "./screens/SubstancesSelectScreen";
import { SubstanceDetailsScreen } from "./screens/SubstanceDetailsScreen";
import { SubstancesCompleteScreen } from "./screens/SubstancesCompleteScreen";

export type SubstancesStackParamList = {
  SubstancesIntro: undefined;
  SubstancesSelect: undefined;
  SubstanceDetails: { substance: SubstanceType };
  SubstancesComplete: undefined;
};

export type SubstancesStackScreenProps<
  T extends keyof SubstancesStackParamList,
> = StackScreenProps<SubstancesStackParamList, T>;

const Stack = createNativeStackNavigator<SubstancesStackParamList>();

export function SubstancesNavigator() {
  return (
    <SubstancesProvider>
      <MedicalHistoryQuestionProvider
        section="substances"
        sectionLabelKey="med_history.review.section_title.substances"
        helpTextKey="med_history.question_screen.flow_help.substances"
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="SubstancesIntro"
            component={SubstancesIntroScreen}
          />
          <Stack.Screen
            name="SubstancesSelect"
            component={SubstancesSelectScreen}
          />
          <Stack.Screen
            name="SubstanceDetails"
            component={SubstanceDetailsScreen}
          />
          <Stack.Screen
            name="SubstancesComplete"
            component={SubstancesCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </SubstancesProvider>
  );
}
